module.exports = __webpack_public_path__ + "static/media/facebook.ec03dd8d.svg";